import { distMi } from "./followedFires";

function vertices(geom, maxPts = 250) {
  if (!geom) return [];
  const polys =
    geom.type === "MultiPolygon" ? geom.coordinates
    : geom.type === "Polygon" ? [geom.coordinates]
    : [];
  const pts = [];
  for (const poly of polys) {
    for (const ring of poly) {
      const step = Math.max(1, Math.floor(ring.length / maxPts));
      for (let i = 0; i < ring.length; i += step) pts.push(ring[i]);
    }
  }
  return pts;
}

/** Pairs of large ACTIVE fires (>= minAcres, < maxContained% contained) whose
 *  perimeter edges are within maxMi of each other — candidates for merging. */
export function findConvergingFires(perimeters, { minAcres = 5000, maxMi = 12, maxContained = 90 } = {}) {
  const big = (perimeters || [])
    .filter(
      (p) =>
        p.geometry &&
        (p.acres ?? 0) >= minAcres &&
        (p.percent_contained == null || p.percent_contained < maxContained),
    )
    .map((p) => {
      const v = vertices(p.geometry);
      let minLat = 90, maxLat = -90, minLon = 180, maxLon = -180;
      for (const [lon, lat] of v) {
        if (lat < minLat) minLat = lat;
        if (lat > maxLat) maxLat = lat;
        if (lon < minLon) minLon = lon;
        if (lon > maxLon) maxLon = lon;
      }
      return { p, v, bbox: { minLat, maxLat, minLon, maxLon } };
    })
    .filter((e) => e.v.length);

  const latTol = maxMi / 69 + 0.02;
  const lonTol = maxMi / 46 + 0.02;
  const pairs = [];
  for (let i = 0; i < big.length; i++) {
    for (let j = i + 1; j < big.length; j++) {
      const A = big[i];
      const B = big[j];
      if (
        A.bbox.minLat - B.bbox.maxLat > latTol ||
        B.bbox.minLat - A.bbox.maxLat > latTol ||
        A.bbox.minLon - B.bbox.maxLon > lonTol ||
        B.bbox.minLon - A.bbox.maxLon > lonTol
      ) continue;
      let best = null;
      for (const a of A.v) {
        for (const b of B.v) {
          const d = distMi(a[1], a[0], b[1], b[0]);
          if (!best || d < best.distance_mi) {
            best = { distance_mi: d, aLat: a[1], aLon: a[0], bLat: b[1], bLon: b[0] };
          }
        }
      }
      if (best && best.distance_mi <= maxMi) {
        pairs.push({
          id: `${A.p.id}-${B.p.id}`,
          nameA: A.p.name,
          nameB: B.p.name,
          ...best,
        });
      }
    }
  }
  return pairs;
}
